<template>
  <div class="loading-spinner-overlay" v-if="visible">
    <div class="loading-spinner-container">
      <i class="bi bi-arrow-repeat spin text-primary" role="status" aria-hidden="true"></i>
      <span class="visually-hidden">Loading...</span>
      <div class="loading-text mt-3" v-if="message">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  visible?: boolean;
  message?: string;
}

withDefaults(defineProps<Props>(), {
  visible: true,
  message: 'Loading...'
});
</script>

<style scoped>
.loading-spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.bi-arrow-repeat {
  font-size: 3rem;
}

.loading-text {
  color: #6c757d;
  font-size: 1rem;
  text-align: center;
}

/* Responsive adjustments */
@media (max-width: 575.98px) {
  .bi-arrow-repeat {
    font-size: 2.5rem;
  }
  
  .loading-text {
    font-size: 0.9rem;
  }
}
</style>